export default __webpack_public_path__ + "static/media/energy-star-box1.27d336e0.png";